import React from 'react';
const OFFSET = 4;
export function dropIndicatorRender(props) {
    const { dropPosition, dropLevelOffset, prefixCls, indent, direction = 'ltr' } = props;
    const startPosition = direction === 'ltr' ? 'left' : 'right';
    const endPosition = direction === 'ltr' ? 'right' : 'left';
    const style = {
        [startPosition]: -dropLevelOffset * indent + OFFSET,
        [endPosition]: 0
    };
    switch (dropPosition) {
        case -1:
            style.top = -3;
            break;
        case 1:
            style.bottom = -3;
            break;
        default:
            style.bottom = -3;
            style[startPosition] = indent + OFFSET;
            break;
    }
    return <div style={style} className={`${prefixCls}-drop-indicator`}/>;
}
